import * as React from 'react';
import * as UI from 'core/ui';
import { ActionButtonDefinition, DialogIcon, PosScreenClassComponent, ScreenSize } from 'pos/ui';
import * as Images from 'pos/Images';
import { Res } from 'core/api';
import { Cols, Col } from 'core/ui';
import { Modal } from 'core/ui-next/modal';

type Props = { tableCompanions: Nullable<number> } & Modal.Actions<Nullable<number>>;
type State = { value: Nullable<number>; }

class GetPartsScreen extends PosScreenClassComponent<Props, State> {

	private form = React.createRef<UI.Form<State>>();
	private txtValue = React.createRef<UI.IntBox<State>>();

	createInitialState(props: Props): Nullable<State> {
		return { value: props.tableCompanions };
	}

	onComponentDidMount(): void {
		this.txtValue.current!.activate();
	}
	onComponentWillUnmount(): void { }

	protected getSize(): ScreenSize {
		return 'small';
	}

	protected getScreenId(): string {
		return 'GET_DIVISION_PARTS';
	}

	protected getTitle(): string {
		return Res.Web.GET_SPLIT_PARTS();
	}

	protected getImage(): string | SvgIcon {
		return Images.SplitTicket;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return this.okCancelButtons({ onOK: this.onOK });
	}

	private onOK = async () => {
		const valid = await this.form.current!.updateModel();
		if (valid)
			this.close(this.state.value!);
	};

	protected getContent(): React.ReactNode {
		const { Form, IntBox } = UI.controlsFor<State>();

		return <Form small ref={this.form} model={this.state}>
			<DialogIcon src={Images.SplitTicket} />
			<Cols>
				<Col width='*' className='text-center m-t-sm text-18'>
					{Res.Web.GET_SPLIT_PARTS()}
				</Col>
			</Cols>
			<Cols>
				<Col width='*' className='m-t-sm'>
					<IntBox ref={this.txtValue} className='text-center' placeholder={Res.Web.GET_SPLIT_PARTS_PLACEHOLDER_LBL()} linkTo={x => x.value} rules={UI.Constraints.greaterThanZero} onKeyDown={UI.whenEnterKey(this.onOK)} required />
				</Col>
			</Cols>
		</Form>;
	}
}

export async function getDivisionParts(tableCompanions: Nullable<number>): Promise<Result<number>> {
	return await Modal.show(GetPartsScreen, { tableCompanions });
}